/**
 * Interface for a logger that accepts log messages at different levels.
 */
export interface IExternalLogger {
  /**
   * @method log - logs a message at the specified log level.
   *
   * @param {LogLevel} level   the log level
   * @param {string} message the log message
   */
  log(level: LogLevel, message: string): void;
}

/**
 * Enumeration of log levels.
 */
export enum LogLevel {
  NONE,
  ERROR,
  WARNING,
  INFO,
  DEBUG,
}

type LogLevelNames = {
  [K in string & keyof typeof LogLevel as (typeof LogLevel)[K]]: K;
};

/**
 * Mapping of log levels to their string representations.
 */
export const LOG_LEVEL_NAMES: LogLevelNames = {
  [LogLevel.NONE]: 'NONE',
  [LogLevel.ERROR]: 'ERROR',
  [LogLevel.WARNING]: 'WARNING',
  [LogLevel.INFO]: 'INFO',
  [LogLevel.DEBUG]: 'DEBUG',
};

export type LogInputType = TemplateStringsArray | string | (() => string);

export type LogParametersType = {
  level: LogLevel;
  strings: LogInputType;
  keys?: unknown[];
};
